import entityReducer from "./documentTemplateEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
